// extracted by mini-css-extract-plugin
export var label = "_2-2";
export var logo = "_2-1";
export var topNav = "_2-0";